import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {KeyboardEvent} from 'react';

import type {CustomerInsightsViewModel} from '../../../types/CustomerInsightsViewModel';
import {CustomerInsightsContent} from '../../CustomerInsightsContent/CustomerInsightsContent';

interface CustomerInsightsPopoverProps {
  id: string;
  viewModel: CustomerInsightsViewModel;
  onClose: VoidFunction;
}

const TITLE_ID_SUFFIX = '-title';

export function CustomerInsightsPopover(props: CustomerInsightsPopoverProps) {
  const titleId = `${props.id}${TITLE_ID_SUFFIX}`;

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    match(event.key)
      .with('Escape', () => {
        event.stopPropagation();
        props.onClose();
      })
      .otherwise(() => undefined);
  };

  return (
    <section
      id={props.id}
      role="dialog"
      aria-labelledby={titleId}
      tabIndex={-1}
      onKeyDown={handleKeyDown}
    >
      <Box
        width={145}
        maxWidth="100vw"
        maxHeight="90vh"
        overflow="hidden"
        backgroundColor="general.white"
        borderRadius="medium"
        boxShadow="elevation_2"
      >
        <CustomerInsightsContent
          viewModel={props.viewModel}
          titleId={titleId}
          isScrollable
          onClose={props.onClose}
        />
      </Box>
    </section>
  );
}
